// Single source of truth for the version shown in the UI.
// Bump alongside package.json "version" on release.
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
